import React from "react";

import { MdmObject, useGetAllObjectsQuery } from "gql/generated/types";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { TableColumn } from "utils/types";
import ItemsTable from "../components/ItemsTable";

const Objects = () => {
  const { data, loading } = useGetAllObjectsQuery();
  const navigate = useNavigate();

  const objectInfoBtn = (rowData: MdmObject) => (
    <Button
      icon="pi pi-info-circle"
      className="p-button-rounded p-button-text"
      onClick={() => navigate(`/objects/${rowData.id}`)}
    />
  );

  const columns: TableColumn<MdmObject>[] = [
    { field: "title", header: "Object Code", sortable: true, filter: true },
    {
      field: "address",
      header: "Address",
      body: rowData =>
        `${rowData.address?.city ?? ""} ${rowData.address?.street ?? ""} ${rowData.address?.houseNumber ?? ""}`,
      sortable: true,
      filter: true,
    },
    { field: "description", header: "Description" },
    { field: "tags", header: "Tags", body: rowData => rowData.tags.join(", ") },
    {
      header: "Actions",
      body: objectInfoBtn,
    },
  ];

  return (
    <div className="card">
      <ItemsTable
        columns={columns}
        data={data?.allMdmObjects as MdmObject[]}
        onToolbarBtnClick={() => navigate("/objects/new")}
        searchFields={["title", "address", "tags"]}
        toolbarBtnLabel="Add Object"
        isLoading={loading}
      />
    </div>
  );
};

export default Objects;
